export default __webpack_public_path__ + "static/media/landing.530e5e3e.jpg";